<template>
  <div>
    <page-header
      :title="$t('user_qr_code')"
      :subtitle="$t('scan_qr_login')"
      icon="mdi-qrcode"
      icon-color="primary"
    />

    <v-container style="max-width: 1170px" class="mt-6">
      <div class="text-center">
        <div class="qr-title">
          <h2 class="mb-5 mt-4">
            {{ toLatin(user.name) }}
            {{ toLatin(user.lastname) }} / ID:
            {{ user.id }}
          </h2>
          <h4>{{ $t("use_qr_web_mobile_login") }}</h4>
        </div>
      </div>
    </v-container>
    <v-container>
      <v-row v-if="loading.getQR" align="center" justify="center" style="min-height: 400px;">
        <v-col cols="auto">
          <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-col>
      </v-row>
      <v-row v-else-if="qrCode" align="center" justify="center">
        <vue-qrcode :value="qrCode" :options="{ width: '350' }"></vue-qrcode>
      </v-row>
      <v-row v-else align="center" justify="center" style="min-height: 400px;">
        <v-col cols="auto">
          <v-alert type="warning" text>
            {{ $t("error_loading_qr_code") }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-card-text align="center" justify="center">
          {{ $t("app_developed_by") }}
          <a href="https://bitlab.rs/" target="_blank" style="text-decoration: none">
            <strong>{{ toLatin(" БитЛаб") }}</strong>
          </a>
        </v-card-text>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import conf from "@/config";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import PageHeader from "@/components/global/PageHeader.vue";
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";
export default {
  mixins: [hasSnackbar],
  components: {
    VueQrcode,
    PageHeader,
  },
  data: () => ({
    conf: conf,
    qrCode: null,
    loading: {
      getQR: false,
    },
  }),
  created() {
    this.qrCode = this.getQR();
  },
  methods: {
    async getQR() {
      if (this.loading.getQR) {
        console.warn("Get QR operation already in progress, skipping duplicate request");
        return;
      }

      this.loading.getQR = true;

      try {
        const res = await userService.getUserHash(this.user.id);
        this.qrCode = JSON.stringify({
          id: this.user.id,
          secure: res.data,
        });
      } catch (error) {
        console.error("Error loading QR code:", error);
        this.showErrorSnackbar(error, this.$t("error_loading_qr_code"));
      } finally {
        this.loading.getQR = false;
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
};
</script>

<style scoped>
.qr-title {
  display: flex;
  flex-direction: column;
}

.qr-title h2,
.qr-title h4 {
  margin: 0 !important;
}

.qr-title h2 {
  margin-top: 30px !important;
}

.qr-title h4 {
  font-weight: normal;
}
</style>
